<template>
  <el-dialog
    :append-to-body="true"
    :title="type == 'add' ? '新增学生档案' : '修改学生档案'"
    :visible.sync="show"
    direction="ltr"
    :before-close="handleClose"
     width="800px"
    :wrapperClosable="false"
    :close-on-press-escape="false"
  >
<div style="height:50vh;overflow-y: scroll;">

    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="130px"
      class="demo-ruleForm"
    >
      <el-form-item label="学生:" prop="studentId">
        <student-select
          v-model="ruleForm.studentId"
          style="width:95%"
        ></student-select>
      </el-form-item>
      <el-form-item label="班级名称:" prop="className">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.className"
          placeholder="请输入班级名称"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="性别:" prop="gender">
        <el-select
          style="width:95%"
          v-model="ruleForm.gender"
          placeholder="请选择性别"
          clearable
          size="small"
        >
          <el-option
            v-for="item in $store.state.select.personnelSex"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出生日期:" prop="dateBirth">
        <el-date-picker
          size="small"
          style="width:95%"
          v-model="ruleForm.dateBirth"
          type="date"
          clearable
          value-format="timestamp"
          placeholder="选择出生日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="班主任:" prop="classTeacher">
        <el-input
          v-model.trim="ruleForm.classTeacher"
          placeholder="请输入班主任"
          clearable
          style="width:95%"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="班主任手机号:" prop="classPhoneNumber">
        <el-input
          v-model.trim="ruleForm.classPhoneNumber"
          placeholder="请输入班主任手机号"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="班主任住址:" prop="homeAddress">
        <el-input
          v-model.trim="ruleForm.homeAddress"
          placeholder="请输入班主任住址"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="紧急联系人姓名:" prop="emergencyContactName">
        <el-input
          v-model.trim="ruleForm.emergencyContactName"
          placeholder="请输入紧急联系人姓名"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="紧急联系人电话:" prop="emergencyContactPhone">
        <el-input
          v-model.trim="ruleForm.emergencyContactPhone"
          placeholder="请输入紧急联系人电话"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="特殊体质情况:" prop="specificPhysicalCondition">
        <el-input
          v-model.trim="ruleForm.specificPhysicalCondition"
          placeholder="请输入特殊体质情况"
          clearable
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3 }"
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="目前情况:" prop="currentCituation">
        <el-select
          v-model="ruleForm.currentCituation"
          placeholder="请选择目前情况"
          clearable
          size="small"
          style="width:95%"
        >
          <el-option label="稳定" :value="0"></el-option>
          <el-option label="持续治疗中" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="初发病确诊时间:" prop="timeOnsetDiagnosis">
        <el-date-picker
          size="small"
          style="width:95%"
          v-model="ruleForm.timeOnsetDiagnosis"
          type="date"
          clearable
          value-format="timestamp"
          placeholder="选择初发病确诊时间"
          :picker-options="pickerOptionsStart"
          @change="changeStart"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="最近发病时间:" prop="timeLastEpisode">
        <el-date-picker
          size="small"
          style="width:95%"
          v-model="ruleForm.timeLastEpisode"
          type="date"
          clearable
          value-format="timestamp"
          placeholder="选择最近发病时间"
          :picker-options="pickerOptionsEnd"
          @change="changeEnd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发病情况:" prop="incidence">
        <el-input
          v-model.trim="ruleForm.incidence"
          placeholder="请输入发病情况"
          clearable
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3 }"
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="家长要求:" prop="parentalRequirements">
        <el-input
          v-model.trim="ruleForm.parentalRequirements"
          placeholder="请输入家长要求"
          clearable
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3 }"
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="学校要求:" prop="schoolRequirements">
        <el-input
          v-model.trim="ruleForm.schoolRequirements"
          placeholder="请输入学校要求"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3 }"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="家长免责证明:" prop="proofOfParentalDisclaimer">
        <upload-image
          v-model="ruleForm.proofOfParentalDisclaimer"
          :uploadLimit="1"
            accept='image/*'
          style="width:95%"
        ></upload-image>
      </el-form-item>
      <el-form-item label="备注说明:" prop="instructionManual">
        <el-input
          v-model.trim="ruleForm.instructionManual"
          placeholder="请输入备注说明"
          clearable
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3 }"
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      
    </el-form>
    
  
</div>
  <span style="margin:20px" slot="footer">
        <el-button type="primary" size="small" @click="saveForm('ruleForm')"
          >提交</el-button
        >
        <el-button @click="handleClose" size="small">取消</el-button>
      </span>
  </el-dialog>
</template>
<script>
import StudentSelect from "./StudentSelect";
import UploadImage from "@/components/UploadImage";
export default {
  name: "AddOrEditSpecialStudents",
  props: {
    drawerShow: {
      type: Boolean,
      default: {
        return: false
      }
    },
    drawerType: {
      type: String,
      default: {
        return: ""
      }
    },
    initialData: {
      type: Object,
      default: {
        return: {}
      }
    }
  },
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      show: false,
      type: "",
      ruleForm: {
        studentId: "", //学生id
        className: "", //班级名称
        gender: "", //性别
        dateBirth: "", //出生日期
        classTeacher: "", //班主任
        classPhoneNumber: "", //班主任手机号
        homeAddress: "", //班主任住址
        emergencyContactName: "", //紧急联系人姓名
        emergencyContactPhone: "", //紧急联系人电话
        specificPhysicalCondition: "", //特殊体质情况
        currentCituation: "", //目前情况
        timeOnsetDiagnosis: "", //初发病确诊时间
        timeLastEpisode: "", //最近发病时间
        incidence: "", //发病情况
        parentalRequirements: "", //家长要求
        schoolRequirements: "", //学校要求
        proofOfParentalDisclaimer: "", //家长免责证明
        instructionManual: "" //备注说明
      },
      rules: {
        studentId: [{ required: true, message: " ", trigger: "change" }],
        className: [{ required: true, message: " ", trigger: "blur" }],
        gender: [{ required: true, message: " ", trigger: "change" }],
        dateBirth: [{ required: true, message: " ", trigger: "change" }],
        classTeacher: [{ required: true, message: " ", trigger: "blur" }],
        classPhoneNumber: [
          { required: true, validator: checkPhone, trigger: "blur" }
        ],
        homeAddress: [{ required: true, message: " ", trigger: "blur" }],
        emergencyContactName: [
          { required: true, message: " ", trigger: "blur" }
        ],
        emergencyContactPhone: [
          { required: true, validator: checkPhone, trigger: "blur" }
        ],
        specificPhysicalCondition: [
          { required: true, message: " ", trigger: "blur" }
        ],
        currentCituation: [{ required: true, message: " ", trigger: "change" }],
        timeOnsetDiagnosis: [
          {
            required: true,
            message: " ",
            trigger: "change"
          }
        ],
        timeLastEpisode: [{ required: true, message: " ", trigger: "change" }],
        incidence: [{ required: true, message: " ", trigger: "blur" }],
        parentalRequirements: [
          { required: true, message: " ", trigger: "blur" }
        ],
        schoolRequirements: [{ required: true, message: " ", trigger: "blur" }],
        proofOfParentalDisclaimer: [
          { required: true, message: " ", trigger: "change" }
        ],
        instructionManual: [{ required: true, message: " ", trigger: "blur" }]
      },
      pickerOptionsStart: {},
      pickerOptionsEnd: {}
    };
  },
  components: {
    StudentSelect,
    "upload-image": UploadImage
  },
  mounted() {},
  methods: {
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.dateBirth = Number(this.ruleForm.dateBirth) / 1000;
          this.ruleForm.timeOnsetDiagnosis =
            Number(this.ruleForm.timeOnsetDiagnosis) / 1000;
          this.ruleForm.timeLastEpisode =
            Number(this.ruleForm.timeLastEpisode) / 1000;
          this.$emit("saveData", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    //   关闭抽屉
    handleClose() {
      this.$emit("handleClose");
    },
    changeStart() {
      // 限制开始时间
      // console.log(this.ruleForm.timeOnsetDiagnosis);
      this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
        disabledDate: (time) => {
          if (this.ruleForm.timeOnsetDiagnosis) {
            return time.getTime() < this.ruleForm.timeOnsetDiagnosis;
          }
        }
      });
    },
    changeEnd() {
      // 限制结束时间
      // console.log(this.ruleForm.timeLastEpisode);
      this.pickerOptionsStart = Object.assign({}, this.pickerOptionsStart, {
        disabledDate: (time) => {
          if (this.ruleForm.timeLastEpisode) {
            //如果没有后面的-8.64e7就是不可以选择今天的
            //减去一天的时间代表可以选择同一天; 1*24*60*60*1000;
            return time.getTime() > this.ruleForm.timeLastEpisode - 8.64e7; //-8.64e7可以让开始时间和结束时间选同一天
          }
        }
      });
    }
  },
  watch: {
    drawerShow: function(nval) {
      this.show = nval;
      if (nval) {
        this.type = this.drawerType || "";
        this.ruleForm = Object.assign({}, this.initialData);
      } else {
        this.$refs.ruleForm.resetFields();
      }
    }
  }
};
</script>
